import { useEffect, useState } from "react";
import api from "@/lib/api";
import { applyProfile, applyFavicon, logoSrc } from "@/context/BrandingContext";
import { AlertTriangle, CheckCircle2 } from "lucide-react";

export function PublicMessage({ icon: Icon = CheckCircle2, tone = "text-emerald-600", title, text, testid }) {
  return (
    <div className="text-center py-6" data-testid={testid}>
      <Icon size={44} className={`mx-auto mb-3 ${tone}`} />
      <h2 className="font-display text-xl font-bold text-slate-900">{title}</h2>
      <p className="text-slate-500 mt-2 text-sm">{text}</p>
    </div>
  );
}

export const PublicError = ({ text, testid = "public-invalid" }) => (
  <PublicMessage icon={AlertTriangle} tone="text-red-500" title="Link ungültig" text={text} testid={testid} />
);

export const footerLine = (brand, appName) => {
  const t = (brand?.footer_text || "").trim();
  return t.startsWith("©") ? t : `© ${new Date().getFullYear()} ${t || appName || brand?.app_name || ""}`;
};

export function PublicShell({ children, wide = false }) {
  const [brand, setBrand] = useState(null);
  useEffect(() => {
    api.get("/branding/public").then((r) => { setBrand(r.data); applyProfile(r.data.profile); applyFavicon(r.data.favicon_url, r.data.favicon_svg_url); }).catch(() => {});
  }, []);
  const logo = logoSrc(brand?.logos?.sidebar);
  return (
    <div className="min-h-screen bg-slate-100 flex flex-col">
      <header className="brand-sidebar px-6 py-5 flex items-center gap-3" style={{ color: "var(--sidebar-text)" }}>
        {logo && <img src={logo} alt={brand?.app_name} className="h-10 object-contain" />}
        <div className="font-display font-bold text-lg">{brand?.app_name}</div>
      </header>
      <main className="flex-1 flex items-start justify-center p-4 sm:p-10">
        <div className={`bg-white w-full ${wide === "full" ? "max-w-7xl" : wide ? "max-w-3xl" : "max-w-xl"} rounded-2xl shadow-sm border border-slate-200 p-6 sm:p-8`}>{children}</div>
      </main>
      <footer className="text-center text-xs text-slate-400 py-4 space-y-0.5" data-testid="public-footer">
        {brand && <div>{footerLine(brand)}</div>}
        {brand?.version && <div>Version {brand.version.replace(/^v/i, "")}</div>}
      </footer>
    </div>
  );
}
